<div class="dashboards-container">
    <!-- * Dashboards -->
    <div class="heading">
        <h4><span class="font-weight-semibold text-success-800" id="PageTitle">Hub Dashboards</span></h4>
    </div>
    <div class="dashboards-panel hub-custom-scrollbar">
        <div class="img-head-container">
            <h3 class="text-success mt-2 header-bold">Progress to the 2030 Goals Dashboards</h3>
            <img class="hub-icon" src="/assets/images/icons/Dashboard_2030_Goals_Logo.png" />
        </div>
        <div class="row p-2">
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/963b6a00-889d-4f0b-b71e-37558ffa4ed7/5ffd5dc16256536700d8?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Path to Progress
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">
                            Tracks early indicators (i.e., strategy and project targets, intermediate results, outcomes) on our path to the 2030 Goals at all
                            scales.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <h3 class="text-success mt-2 header-bold">Management Dashboards</h3>
        <div class="row p-2">
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/f5f434ff-da75-4091-b473-d8ba5d425a28/fd2678379b958f2d3c2b?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                2030 Goals Project Tracking
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Tracks progress made by teams across TNC toward our 2030 Goals.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/8878857f-73de-4674-a88d-8b86e116bd2b/b61169d4bb53e1cd7738?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Conservation Management
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Tracks project progress toward their outcomes and intermediate results.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/47850e84-05dc-4f39-a8b1-17e895ed878e/578dc3073400802b36df?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                North America Targets
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Tracks progress toward 2030 Goal targets set by North America divisions.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/d3bf2ad0-ed1b-4a52-9d77-e4ba84f10f8e/ReportSection508adbf0850eeb06e70e?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Strategy Management
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Tracks strategy progress toward their outcomes and intermediate results.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/a02b6a1f-c3e0-4cf2-93d4-8fa80678db90/742c9c2d67619e66a284?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Strategy Review - Prototype
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Dashboard to review progress made by strategies with a summary of how progress was achieved.</p>
                    </div>
                </div>
            </div>
        </div>
        <h3 class="text-success mt-2 header-bold">Data Review Dashboards</h3>
        <div class="row p-2">
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/5f82629b-6499-4a6e-9472-18b9cbd668f8/f85de06aa2d936aa79c3?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Hub Data Completeness
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Tracks completeness of data on Hub strategies and projects.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2">
                <div class="media flex-sm-row">
                    <div class="mr-sm-3 mb-2 mb-sm-0 mr-3">
                        <div class="card-img-actions">
                            <i class="icon-chart icon-3x text-success-300"></i>
                        </div>
                    </div>
                    <div class="media-body">
                        <h3 class="media-title">
                            <a
                                href="https://app.powerbi.com/groups/me/apps/96f23e46-f7f2-4c37-bbee-b138d1422125/reports/f36d770d-ec9f-4a9c-a156-3c3dbb8d4967/ReportSection639733bb8d8fe5f2675f?ctid=79be6dc1-d78e-4bbb-b22b-d994c0a417a7&experience=power-bi"
                                target="_blank"
                            >
                                Hub Data Review
                            </a>
                        </h3>
                        <ul class="list-inline list-inline-dotted text-muted mb-2">
                            <li class="list-inline-item">Dashboard</li>
                        </ul>
                        <p class="narrative">Displays basic information on Hub records.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- * Dashboard Guidance -->
    <div class="guidance-panel">
        <div class="icon-panel">
            <i class="icon-help icon-3x text-primary-300"></i>
        </div>
        <div class="guidance-content">
            <h3 class="media-title text-success">Hub Dashboard Guidance</h3>
            <ul class="list-inline list-inline-dotted text-muted mb-2">
                <li class="list-inline-item">Training and Guidance</li>
            </ul>
            <p class="narrative">Guidance on how to navigate these dashboards can be found on the Hub Connect page.</p>
            <a
                href="https://thenatureconservancy462.sharepoint.com/sites/Conservation/SitePages/The-Hub.aspx"
                target="_blank"
                class="hub-icon-button"
                style="width: 260px"
            >
                <b><i class="icon-help"></i></b>
                HUB CONNECT PAGE
            </a>
        </div>
    </div>
</div>
